export const TERMS_OF_USE_URL = "https://kahun.com/terms-of-service/";
export const PRIVACY_POLICY_URL = "https://kahun.com/privacy-policy/";
export const COOKIE_POLICY_URL = "https://www.kahun.com/cookie-settings/";
